export default (
  state = {
    activeTab: '',
    activeTabIndex: 0,
    shouldGoogleMapsLoad: false,
  },
  action,
) => {
  switch (action.type) {
    case 'CLEAR_ACTIVE_TAB':
      return {
        ...state,
        activeTab: '',
      };
    case 'POPULATE_TAB':
      return {
        ...state,
        activeTab: action.target,
      };
    case 'POPULATE_TAB_DESKTOP':
      return {
        ...state,
        activeTab: action.target,
        activeTabIndex: action.index,
      };
    case 'SHOULD_GOOGLE_MAPS_LOAD':
      // console.log('pop')
      return {
        ...state,
        shouldGoogleMapsLoad: true,
      };
    default:
      return state;
  }
};
